import { themes } from "./theme";
export const ver = 'A6108'
export const verData = {
  "A6301": {
    title: "SEN VÀNG",
    moneyType: 'VND',
    url: 'https://senvang3.com/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.A6301,
    areaCode: "66",
    lan: "vi",
    loginBG: require("@tt/assets/login/loginBG_A6301.png"),
    // randMoneyTypes: [
    //   { symbol: "฿", abbr: "THB", interval: [100, 300000] },
    //   { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
    //   { symbol: "$", abbr: "USDT", interval: [100, 10000] },
    //   { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    // ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USDT", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6301_test": {
    title: "SEN VÀNG",
    moneyType: 'VND',
    url: ' https://ga6301.gtzs.cc/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.A6301,
    areaCode: "66",
    lan: "vi",
    loginBG: require("@tt/assets/login/loginBG_A6301.png"),
    // randMoneyTypes: [
    //   { symbol: "฿", abbr: "THB", interval: [100, 300000] },
    //   { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
    //   { symbol: "$", abbr: "USDT", interval: [100, 10000] },
    //   { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    // ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USDT", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6402": {
    title: "Galaxy Macau",
    moneyType: '฿',
    needBank: false,
    // url: 'https://a5888.vip/',
    url: 'https://venetianvn1.com/',
    navTheme: "#0d192c",
    theme: "#00bbfe",
    pagesBG: "#0d192c",
    areaCode: "66",
    lan: "en",
    loginBG: require("@tt/assets/login/loginBG.png"),
    randMoneyTypes: [
      { symbol: "฿", abbr: "THB", interval: [100, 300000] },
      { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
      { symbol: "$", abbr: "USD", interval: [100, 10000] },
      { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USD", "GBP"],
    useNewUsername: true,
    // tabbar: {
    //   background: "#2a2b35",
    //   // selectedColor: "#0073e4",
    //   color: "#eee",
    //   type: "image",
    //   pages: [
    //     {
    //       text: 'newTab.home',
    //       pagePath: 'goods',
    //       component: () => import("@/view/goods"),
    //       iconPath: require("@tt/assets/tabbar/home.png"),
    //       selectedIconPath: require("@tt/assets/tabbar/home_active.png"),
    //       isSpecial: false,
    //     },
    //     {
    //       text: `${'newTab.order'}`,
    //       pagePath: 'cart',
    //       component: () => import('@/view/cart'),
    //       iconPath: require("@tt/assets/tabbar/record.png"),
    //       selectedIconPath: require("@tt/assets/tabbar/record_active.png"),
    //       isSpecial: false,
    //     },
    //     {
    //       text: `${'page.games'}`,
    //       pagePath: 'Merchants',
    //       component: () => import('@/view/new/merchants'),
    //       iconPath: require("@tt/assets/tabbar/game.png"),
    //       selectedIconPath: require("@tt/assets/tabbar/game_active.png"),
    //       // isSpecial: true,
    //     },
    //     {
    //       text: `tab.activity`,
    //       pagePath: 'activity',
    //       component: () => import('@/view/new/activity'),
    //       iconPath: require("@tt/assets/tabbar/prize.png"),
    //       selectedIconPath: require("@tt/assets/tabbar/prize_active.png"),
    //       isSpecial: false,
    //     },
    //     {
    //       text: `${'newTab.my'}`,
    //       pagePath: 'user',
    //       component: () => import('@/view/user'),
    //       iconPath: require("@tt/assets/tabbar/mine.png"),
    //       selectedIconPath: require("@tt/assets/tabbar/mine_active.png"),
    //       isSpecial: false,
    //     },
    //   ]
    // }
  },
  'A6402_test': {
    title: "Galaxy Macau",
    moneyType: '฿',
    url: 'http://149.129.175.229:6401/',
    navTheme: "#0d192c",
    theme: "#00bbfe",
    pagesBG: "#0d192c",
    areaCode: "66",
    lan: "th",
    loginBG: require("@tt/assets/login/loginBG.png"),
    needBank: true,
    // tabbar: {
    //   background: "#2a2b35",
    //   // selectedColor: "#0073e4",
    //   color: "#eee",
    //   type: "image",
    //   pages: [
    //     {
    //       text: 'newTab.home',
    //       pagePath: 'goods',
    //       component: () => import("@/view/goods"),
    //       iconPath: require("@tt/assets/tabbar/home.png"),
    //       selectedIconPath: require("@tt/assets/tabbar/home_active.png"),
    //       isSpecial: false,
    //     },
    //     {
    //       text: `${'newTab.order'}`,
    //       pagePath: 'cart',
    //       component: () => import('@/view/cart'),
    //       iconPath: require("@tt/assets/tabbar/record.png"),
    //       selectedIconPath: require("@tt/assets/tabbar/record_active.png"),
    //       isSpecial: false,
    //     },
    //     {
    //       text: `${'page.games'}`,
    //       pagePath: 'Merchants',
    //       component: () => import('@/view/new/merchants'),
    //       iconPath: require("@tt/assets/tabbar/game.png"),
    //       selectedIconPath: require("@tt/assets/tabbar/game_active.png"),
    //       // isSpecial: true,
    //     },
    //     {
    //       text: `tab.activity`,
    //       pagePath: 'activity',
    //       component: () => import('@/view/new/activity'),
    //       iconPath: require("@tt/assets/tabbar/prize.png"),
    //       selectedIconPath: require("@tt/assets/tabbar/prize_active.png"),
    //       isSpecial: false,
    //     },
    //     {
    //       text: `${'newTab.my'}`,
    //       pagePath: 'user',
    //       component: () => import('@/view/user'),
    //       iconPath: require("@tt/assets/tabbar/mine.png"),
    //       selectedIconPath: require("@tt/assets/tabbar/mine_active.png"),
    //       isSpecial: false,
    //     },
    //   ]
    // }
  },
  "T7386": {
    title: 'jazp',
    moneyType: '₹',
    needBank: true,
    areaCode: 91,
    // useMoreArea: true,
    cusArea: [
      {
        "en": "United Arab Emirates",
        "zh": "阿拉伯联合酋长国",
        "code": "AE",
        "areaCode": "971"
      },
      {
        "en": "India",
        "zh": "印度",
        "code": "IN",
        "areaCode": "91"
      },
      {
        "en": "Saudi Arabia",
        "zh": "沙特阿拉伯",
        "code": "SA",
        "areaCode": "966"
      },
      {
        "en": "Kuwait",
        "zh": "科威特",
        "code": "KW",
        "areaCode": "965"
      }
    ],
    lan: 'en',
    needCode: true,
    url: 'https://jazpshop.vip/',
    // bankInput: true,
    vipHide: false,
    bankCardLimit: 11,
    levelType: 'recharge',
    useNewPatener: true,
    useNewCampanyImg: true,
    useNewInviteCode: true,
    // newRecharge: true, // 新版本修改后新增参数
    useNewMine: true,
    pathNewRecharge: true, // 跳转新的充值页面
    homeProfitInterval: [10, 5000],
    homeProfitIntervalMax: [11500, 11999],
    // useNewWithdraw: true,
    defaultBank: "HDFC",
    dateFormat: "MM/dd/yyyy HH:mm:ss",
    dateFormatNoTime: "MM/dd/yyyy",
    banks: [
      {
        value: "HDFC",
        text: "HDFC",
      },
    ],
  },
  "A6405": {
    title: "SunCity",
    moneyType: '฿',
    url: 'https://a1688888.cyou/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.light,
    areaCode: "66",
    lan: "en",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    randMoneyTypes: [
      { symbol: "฿", abbr: "THB", interval: [100, 300000] },
      { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
      { symbol: "$", abbr: "USD", interval: [100, 10000] },
      { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USD", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6405Test": {
    title: "SunCity",
    moneyType: '฿',
    url: 'http://149.129.175.229:6405/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.light,
    areaCode: "66",
    lan: "en",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    randMoneyTypes: [
      { symbol: "฿", abbr: "THB", interval: [100, 300000] },
      { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
      { symbol: "$", abbr: "USD", interval: [100, 10000] },
      { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USD", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6406": {
    title: "venetianvn",
    moneyType: 'USD',
    url: 'https://venetianvn8.com/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.a6406Light,
    areaCode: "66",
    lan: "vi",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    // randMoneyTypes: [
    //   { symbol: "฿", abbr: "THB", interval: [100, 300000] },
    //   { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
    //   { symbol: "$", abbr: "USD", interval: [100, 10000] },
    //   { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    // ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USD", "GBP"],
    needBank: true,
    useNewUsername: true,
    notLoginToRegist: false
  },
  "A6419": {
    title: "Casino Lisboa",
    moneyType: 'USD',
    url: 'https://xinpujing.org/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.a6419Light,
    areaCode: "66",
    lan: "vi",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    // randMoneyTypes: [
    //   { symbol: "฿", abbr: "THB", interval: [100, 300000] },
    //   { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
    //   { symbol: "$", abbr: "USD", interval: [100, 10000] },
    //   { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    // ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USD", "GBP"],
    needBank: true,
    useNewUsername: true,
    notLoginToRegist: true
  },
  "A6406_test": {
    title: "venetianvn",
    moneyType: 'USD',
    url: 'https://ga6408.gtzs.cc/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.a6406Light,
    areaCode: "66",
    lan: "vi",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    // randMoneyTypes: [
    //   { symbol: "฿", abbr: "THB", interval: [100, 300000] },
    //   { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
    //   { symbol: "$", abbr: "USD", interval: [100, 10000] },
    //   { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    // ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USD", "GBP"],
    needBank: true,
    useNewUsername: true,
    notLoginToRegist: true
  },
  "A6408": {
    title: "Marina Bay Sands",
    moneyType: '$',
    url: 'https://hi689.xyz/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.light,
    areaCode: "66",
    lan: "vi",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    randMoneyTypes: [
      { symbol: "฿", abbr: "THB", interval: [100, 300000] },
      { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
      { symbol: "$", abbr: "USDT", interval: [100, 10000] },
      { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USDT", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6408_test": {
    title: "Marina Bay Sands",
    moneyType: '$',
    url: 'https://ga6408.gtzs.cc/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.light,
    areaCode: "66",
    lan: "vi",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    randMoneyTypes: [
      { symbol: "฿", abbr: "THB", interval: [100, 300000] },
      { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
      { symbol: "$", abbr: "USDT", interval: [100, 10000] },
      { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USDT", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6408_test_zh": {
    title: "Marina Bay Sands",
    moneyType: '$',
    url: 'https://ga6408.gtzs.cc/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.light,
    areaCode: "66",
    lan: "zh",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    randMoneyTypes: [
      { symbol: "฿", abbr: "THB", interval: [100, 300000] },
      { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
      { symbol: "$", abbr: "USDT", interval: [100, 10000] },
      { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USDT", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6409": {
    title: "Marina Bay Sands",
    moneyType: '$',
    url: 'https://idn999.cc/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.light,
    areaCode: "66",
    lan: "idn",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    randMoneyTypes: [
      { symbol: "฿", abbr: "THB", interval: [100, 300000] },
      { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
      { symbol: "$", abbr: "USDT", interval: [100, 10000] },
      { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USDT", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6422": {
    title: "MARINA BAY SANDS",
    moneyType: '$',
    url: 'https://marinabaysandsid.com/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.a6422light,
    areaCode: "66",
    lan: "idn",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    randMoneyTypes: [
      { symbol: "฿", abbr: "THB", interval: [100, 300000] },
      { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
      { symbol: "$", abbr: "USDT", interval: [100, 10000] },
      { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USDT", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6422_2": {
    title: "Venetian",
    moneyType: '$',
    url: 'https://venetianid.com/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.a6422light,
    areaCode: "66",
    lan: "idn",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    randMoneyTypes: [
      { symbol: "฿", abbr: "THB", interval: [100, 300000] },
      { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
      { symbol: "$", abbr: "USDT", interval: [100, 10000] },
      { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USDT", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6410": {
    title: "Ma Cao",
    moneyType: '$',
    url: 'https://xskt555.com/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.light,
    areaCode: "66",
    lan: "vi",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    randMoneyTypes: [
      { symbol: "฿", abbr: "THB", interval: [100, 300000] },
      { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
      { symbol: "$", abbr: "USDT", interval: [100, 10000] },
      { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USDT", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6411": {
    title: "Marina Bay Sands",
    moneyType: 'Rp ',
    url: 'https://66688.cyou/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.light,
    areaCode: "66",
    lan: "idn",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    // randMoneyTypes: [
    //   { symbol: "฿", abbr: "THB", interval: [100, 300000] },
    //   { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
    //   { symbol: "$", abbr: "USDT", interval: [100, 10000] },
    //   { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    // ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USDT", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6412": {
    title: "Marina Bay Sands",
    moneyType: 'Rp.',
    url: 'https://toto24.vip/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.light,
    areaCode: "66",
    lan: "idn",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    randMoneyTypes: [
      { symbol: "฿", abbr: "THB", interval: [10000000, 900000000] },
      { symbol: "RM", abbr: "RM", interval: [10000000, 600000000] },
      { symbol: "$", abbr: "USDT", interval: [10000000, 1000000000] },
      { symbol: "S$", abbr: "SGD", interval: [10000000, 400000000] },
      { symbol: "Rp.", abbr: "RP", interval: [10000000, 900000000] },
    ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USDT", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6413": {
    title: "MARINA BAY SAND",
    moneyType: '$',
    url: 'https://casino06.vip/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.light,
    areaCode: "66",
    lan: "vi",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    randMoneyTypes: [
      { symbol: "฿", abbr: "THB", interval: [100, 300000] },
      { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
      { symbol: "$", abbr: "USDT", interval: [100, 10000] },
      { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USDT", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6417": {
    title: "MARINA BAY SAND",
    moneyType: '$',
    url: 'https://casino67.vip/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.light,
    areaCode: "66",
    lan: "vi",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    randMoneyTypes: [
      { symbol: "฿", abbr: "THB", interval: [100, 300000] },
      { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
      { symbol: "$", abbr: "USDT", interval: [100, 10000] },
      { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USDT", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6418": {
    title: "MARINA BAY SAND",
    moneyType: '$',
    url: 'https://haoyunlai999.cyou/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.light,
    areaCode: "66",
    lan: "vi",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    randMoneyTypes: [
      { symbol: "฿", abbr: "THB", interval: [100, 300000] },
      { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
      { symbol: "$", abbr: "USDT", interval: [100, 10000] },
      { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USDT", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6420": {
    title: "SANDS",
    moneyType: '$',
    url: 'https://sands567.com/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.a6420light,
    areaCode: "66",
    lan: "ko",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    randMoneyTypes: [
      { symbol: "฿", abbr: "THB", interval: [100, 300000] },
      { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
      { symbol: "$", abbr: "USDT", interval: [100, 10000] },
      { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USDT", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6421": {
    title: "LOTTERY",
    moneyType: '$',
    url: 'https://casino0611.cc/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.a6421light,
    areaCode: "66",
    lan: "vi",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    randMoneyTypes: [
      { symbol: "฿", abbr: "THB", interval: [100, 300000] },
      { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
      { symbol: "$", abbr: "USDT", interval: [100, 10000] },
      { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USDT", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6421_test": {
    title: "CASINO",
    moneyType: '$',
    url: 'http://223.26.52.135:16421/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.a6421light,
    areaCode: "66",
    lan: "vi",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    randMoneyTypes: [
      { symbol: "฿", abbr: "THB", interval: [100, 300000] },
      { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
      { symbol: "$", abbr: "USDT", interval: [100, 10000] },
      { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USDT", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6423": {
    title: "CASINO",
    moneyType: '$',
    url: 'http://223.26.52.135:16423/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.a6423light,
    areaCode: "66",
    lan: "vi",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    randMoneyTypes: [
      { symbol: "฿", abbr: "THB", interval: [100, 300000] },
      { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
      { symbol: "$", abbr: "USDT", interval: [100, 10000] },
      { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USDT", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6424": {
    title: "Instagramm",
    moneyType: '₺',
    url: 'https://instagramm5153.top/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.a6421light,
    areaCode: "66",
    lan: "tr",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    randMoneyTypes: [
      { symbol: "฿", abbr: "THB", interval: [100, 300000] },
      { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
      { symbol: "$", abbr: "USDT", interval: [100, 10000] },
      { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USDT", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6416": {
    title: "Marina Bay Sands",
    moneyType: '$',
    url: 'https://vn566888.com/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.light,
    areaCode: "66",
    lan: "vi",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    randMoneyTypes: [
      { symbol: "฿", abbr: "THB", interval: [100, 300000] },
      { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
      { symbol: "$", abbr: "USDT", interval: [100, 10000] },
      { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USDT", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6451": {
    title: "Dream Vip",
    moneyType: '฿',
    url: 'https://ht515.com/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.light,
    areaCode: "66",
    lan: "en",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    randMoneyTypes: [
      { symbol: "฿", abbr: "THB", interval: [100, 300000] },
      { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
      { symbol: "$", abbr: "USD", interval: [100, 10000] },
      { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    ],
    rechargeSelectCurrency: ["VND", "RM", "SGD", "USD", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6501": {
    // title: "venetianvn",
    title: "QUỸ UPS",
    moneyType: 'VND',
    url: 'https://tamlongviet7.com/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.heartLight,
    areaCode: "66",
    lan: "vi",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    // randMoneyTypes: [
    //   { symbol: "฿", abbr: "THB", interval: [100, 300000] },
    //   { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
    //   { symbol: "$", abbr: "USD", interval: [100, 10000] },
    //   { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    // ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USD", "GBP"],
    needBank: true,
    useNewUsername: true,
    notLoginToRegist: true
  },
  "A6505": {
    // title: "venetianvn",
    title: "Mái Ấm Tre Xanh",
    moneyType: 'VND',
    url: 'https://matx.news/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.heartLight,
    areaCode: "66",
    lan: "vi",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    // randMoneyTypes: [
    //   { symbol: "฿", abbr: "THB", interval: [100, 300000] },
    //   { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
    //   { symbol: "$", abbr: "USD", interval: [100, 10000] },
    //   { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    // ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USD", "GBP"],
    needBank: true,
    useNewUsername: true,
    notLoginToRegist: true
  },
  "A6506": {
    title: "Tấm Lòng Vàng",
    moneyType: 'VND',
    url: 'https://tlv4444.com/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.heartLight,
    areaCode: "66",
    lan: "vi",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    // randMoneyTypes: [
    //   { symbol: "฿", abbr: "THB", interval: [100, 300000] },
    //   { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
    //   { symbol: "$", abbr: "USD", interval: [100, 10000] },
    //   { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    // ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USD", "GBP"],
    needBank: true,
    useNewUsername: true,
    notLoginToRegist: true
  },
  "A6501_2": {
    // title: "venetianvn",
    title: "NỤ CƯỜI XINH",
    moneyType: 'VND',
    url: 'https://tamlongviet7.com/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.a6501_2,
    areaCode: "66",
    lan: "vi",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    // randMoneyTypes: [
    //   { symbol: "฿", abbr: "THB", interval: [100, 300000] },
    //   { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
    //   { symbol: "$", abbr: "USD", interval: [100, 10000] },
    //   { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    // ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USD", "GBP"],
    needBank: true,
    useNewUsername: true,
    notLoginToRegist: true
  },
  "A6506_old": {
    title: "venetianvn",
    moneyType: 'VND',
    url: 'https://nhanai999.com/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    theme: "#FE6807",
    themes: themes.heartLight,
    areaCode: "66",
    lan: "vi",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    // randMoneyTypes: [
    //   { symbol: "฿", abbr: "THB", interval: [100, 300000] },
    //   { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
    //   { symbol: "$", abbr: "USD", interval: [100, 10000] },
    //   { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    // ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USD", "GBP"],
    needBank: true,
    useNewUsername: true,
    notLoginToRegist: true
  },
  "A6501Test": {
    title: "venetianvn",
    moneyType: 'VND',
    url: 'https://ga6501.csvip.top/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.heartLight,
    areaCode: "66",
    lan: "vi",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    // randMoneyTypes: [
    //   { symbol: "฿", abbr: "THB", interval: [100, 300000] },
    //   { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
    //   { symbol: "$", abbr: "USD", interval: [100, 10000] },
    //   { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    // ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USD", "GBP"],
    needBank: true,
    useNewUsername: true,
    notLoginToRegist: true
  },
  "A6508": {
    title: "saigonchildren",
    moneyType: 'VND',
    url: 'https://saigonchildren04.com/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.heartLight,
    areaCode: "66",
    lan: "vi",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    // randMoneyTypes: [
    //   { symbol: "฿", abbr: "THB", interval: [100, 300000] },
    //   { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
    //   { symbol: "$", abbr: "USD", interval: [100, 10000] },
    //   { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    // ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USD", "GBP"],
    needBank: true,
    useNewUsername: true,
    notLoginToRegist: true
  },
  "A6506_oldTest": {
    title: "venetianvn",
    moneyType: 'VND',
    url: 'https://ga6501.gtzs.cc/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    theme: "#FE6807",
    themes: themes.heartLight,
    areaCode: "66",
    lan: "vi",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    // randMoneyTypes: [
    //   { symbol: "฿", abbr: "THB", interval: [100, 300000] },
    //   { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
    //   { symbol: "$", abbr: "USD", interval: [100, 10000] },
    //   { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    // ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USD", "GBP"],
    needBank: true,
    useNewUsername: true,
    notLoginToRegist: true
  },
  "T7201": {
    title: 'VIPMART',
    moneyType: 'đồng',
    needBank: true,
    isLinkGame: true,
    // areaCode: 1,
    appVersion: "101",
    lan: 'vi',
    lans: [
      // { name: "Português", value: "pt", icon: require("@tt/i18n/icon/pt.png"), areaCode: 55 },
      // { name: "English", value: "en", icon: require("@tt/i18n/icon/en.png"), areaCode: 1 },
      // { name: "Español", value: "es", icon: require("@tt/i18n/icon/es.png"), areaCode: 34 },
      { name: "Tiếng Việt", value: "vi", icon: require("@tt/i18n/icon/vi.png"), areaCode: 1 },
      // { name: "繁體中文", value: "tw", icon: require("@tt/i18n/icon/tw.png"), areaCode: 1 }
    ],
    rechargeList: [
      "20000",
      "500000",
      "1000000",
      "5000000",
      "10000000",
      "30000000"
    ],
    needCode: true,
    url: 'https://gt7201.csvip.top/',
    // bankInput: true,
    vipHide: false,
    needFromid: true,
    // bankCardLimit: 11,
    banUserName: false,
    notLoginToRegist: true,
    levelType: 'recharge',
    newRecharge: true, // 新版本修改后新增参数
    useNewMine: true,
    // pathNewRecharge: true, // 跳转新的充值页面
    homeProfitInterval: [10, 5000],
    homeProfitIntervalMax: [11500, 11999],
    // useNewWithdraw: true,
    // addCardForms: ["account", "bank", "card", "ifsc"],
    addCardForms: ["account", "bank", "card"],
    theme: "#ff6400",
    navBg: ["#f53d2c", "#ff6534"],
    navBGToBottom: true,
    noticeIconColor: "#000",
    loginSetLans: false,
    homeShowBalanceAtTop: true,
    homeShowLevels: true,
    hallPhonenumStart: 9,
    mineShowAboutBar: true,
    moneyFormatWithBrazil: true,
    hasGiftRate: true,
    banEditBank: true,
    mineShowWallet: true,
    useSignGift: true,
    hideNotice: true,
    registerHasRead: true,
    levelsReverse: true,
    banDefaultRead: true,
    nullPng: require("@tt/assets/Img/null/T7404.png"),
    messageNullPng: require("@tt/assets/Img/null/T7404_message.png"),
    addressNullPng: require("@tt/assets/Img/null/T7404_address.png"),
    nulltrade: require("@tt/assets/Img/null/T7404_1.png"),
    unreadBg: "#fcc400",
    unreadColor: "#000",
    homeTheme: "#0073e4",
    dateFormat: "dd/MM/yyyy",
    banks: [
      { value: "EMAIL", text: "EMAIL" },
      { value: "PHONE", text: "PHONE" },
      { value: "CPF", text: "CPF" },
      { value: "CNPJ", text: "CNPJ" },
      { value: "RANDOM", text: "RANDOM" },
    ]
  },
  "T7202": {
    title: 'VIPMART',
    moneyType: '฿',
    needBank: true,
    isLinkGame: true,
    // areaCode: 1,
    appVersion: "101",
    lan: 'vi',
    lans: [
      // { name: "Português", value: "pt", icon: require("@tt/i18n/icon/pt.png"), areaCode: 55 },
      // { name: "English", value: "en", icon: require("@tt/i18n/icon/en.png"), areaCode: 1 },
      // { name: "Español", value: "es", icon: require("@tt/i18n/icon/es.png"), areaCode: 34 },
      { name: "Tiếng Việt", value: "vi", icon: require("@tt/i18n/icon/vi.png"), areaCode: 1 },
      // { name: "繁體中文", value: "tw", icon: require("@tt/i18n/icon/tw.png"), areaCode: 1 }
    ],
    rechargeList: [
      "20000",
      "500000",
      "1000000",
      "5000000",
      "10000000",
      "30000000"
    ],
    needCode: true,
    url: 'https://gt7192.csvip.top/',
    // bankInput: true,
    vipHide: false,
    needFromid: true,
    // bankCardLimit: 11,
    banUserName: false,
    notLoginToRegist: true,
    levelType: 'recharge',
    newRecharge: true, // 新版本修改后新增参数
    useNewMine: true,
    // pathNewRecharge: true, // 跳转新的充值页面
    homeProfitInterval: [10, 5000],
    homeProfitIntervalMax: [11500, 11999],
    // useNewWithdraw: true,
    // addCardForms: ["account", "bank", "card", "ifsc"],
    addCardForms: ["account", "bank", "card"],
    theme: "#ff6400",
    navBg: ["#f53d2c", "#ff6534"],
    navBGToBottom: true,
    noticeIconColor: "#000",
    loginSetLans: false,
    homeShowBalanceAtTop: true,
    homeShowLevels: true,
    hallPhonenumStart: 9,
    mineShowAboutBar: true,
    moneyFormatWithBrazil: true,
    hasGiftRate: true,
    banEditBank: true,
    mineShowWallet: true,
    useSignGift: true,
    hideNotice: true,
    registerHasRead: true,
    levelsReverse: true,
    banDefaultRead: true,
    nullPng: require("@tt/assets/Img/null/T7404.png"),
    messageNullPng: require("@tt/assets/Img/null/T7404_message.png"),
    addressNullPng: require("@tt/assets/Img/null/T7404_address.png"),
    nulltrade: require("@tt/assets/Img/null/T7404_1.png"),
    unreadBg: "#fcc400",
    unreadColor: "#000",
    homeTheme: "#0073e4",
    dateFormat: "dd/MM/yyyy",
    banks: [
      { value: "EMAIL", text: "EMAIL" },
      { value: "PHONE", text: "PHONE" },
      { value: "CPF", text: "CPF" },
      { value: "CNPJ", text: "CNPJ" },
      { value: "RANDOM", text: "RANDOM" },
    ]
  },
  "T7201Test": {
    title: 'VIPMART',
    moneyType: 'đồng',
    needBank: true,
    isLinkGame: true,
    // areaCode: 1,
    appVersion: "101",
    lan: 'vi',
    lans: [
      // { name: "Português", value: "pt", icon: require("@tt/i18n/icon/pt.png"), areaCode: 55 },
      // { name: "English", value: "en", icon: require("@tt/i18n/icon/en.png"), areaCode: 1 },
      // { name: "Español", value: "es", icon: require("@tt/i18n/icon/es.png"), areaCode: 34 },
      { name: "Tiếng Việt", value: "vi", icon: require("@tt/i18n/icon/vi.png"), areaCode: 1 },
      // { name: "繁體中文", value: "tw", icon: require("@tt/i18n/icon/tw.png"), areaCode: 1 }
    ],
    rechargeList: [
      "20000",
      "500000",
      "1000000",
      "5000000",
      "10000000",
      "30000000"
    ],
    needCode: true,
    url: 'https://gt7201.gtzs.cc/',
    // bankInput: true,
    vipHide: false,
    needFromid: true,
    // bankCardLimit: 11,
    banUserName: false,
    notLoginToRegist: true,
    levelType: 'recharge',
    newRecharge: true, // 新版本修改后新增参数
    useNewMine: true,
    // pathNewRecharge: true, // 跳转新的充值页面
    homeProfitInterval: [10, 5000],
    homeProfitIntervalMax: [11500, 11999],
    // useNewWithdraw: true,
    // addCardForms: ["account", "bank", "card", "ifsc"],
    addCardForms: ["account", "bank", "card"],
    theme: "#ff6400",
    navBg: ["#f53d2c", "#ff6534"],
    navBGToBottom: true,
    noticeIconColor: "#000",
    loginSetLans: false,
    homeShowBalanceAtTop: true,
    homeShowLevels: true,
    hallPhonenumStart: 9,
    mineShowAboutBar: true,
    moneyFormatWithBrazil: true,
    hasGiftRate: true,
    banEditBank: true,
    mineShowWallet: true,
    useSignGift: true,
    hideNotice: true,
    registerHasRead: true,
    levelsReverse: true,
    banDefaultRead: true,
    nullPng: require("@tt/assets/Img/null/T7404.png"),
    messageNullPng: require("@tt/assets/Img/null/T7404_message.png"),
    addressNullPng: require("@tt/assets/Img/null/T7404_address.png"),
    nulltrade: require("@tt/assets/Img/null/T7404_1.png"),
    unreadBg: "#fcc400",
    unreadColor: "#000",
    homeTheme: "#0073e4",
    dateFormat: "dd/MM/yyyy",
    banks: [
      { value: "EMAIL", text: "EMAIL" },
      { value: "PHONE", text: "PHONE" },
      { value: "CPF", text: "CPF" },
      { value: "CNPJ", text: "CNPJ" },
      { value: "RANDOM", text: "RANDOM" },
    ]
  },
  "T7404": {
    title: 'Amazonbot',
    moneyType: 'USDT',
    needBank: true,
    areaCode: 966,
    lan: 'ar',
    needCode: true,
    url: 'https://sales777.vip/',
    unreadBg: "#febd68",
    unreadColor: "#000",
    bankInput: true,
    vipHide: false,
    bankCardLimit: 11,
    levelType: 'recharge',
    newRecharge: true, // 新版本修改后新增参数
    useNewMine: true,
    pathNewRecharge: true, // 跳转新的充值页面
    homeProfitInterval: [10, 5000],
    homeProfitIntervalMax: [11500, 11999],
    useNewWithdraw: true,
    dateFormat: "MM/dd/yyyy HH:mm:ss",
    dateFormatNoTime: "MM/dd/yyyy",
    theme: "#ff9300",
    noticeIconColor: "#000",
    homeTheme: "#e9600a",
    navBg: "#fff",
    hideLoginFooter: true
  },
  "T7404_test": {
    title: 'Amazonbot',
    moneyType: 'USDT',
    needBank: true,
    areaCode: 966,
    lan: 'ar',
    needCode: true,
    url: 'https://gt7404.gtzs.cc/',
    unreadBg: "#febd68",
    unreadColor: "#000",
    bankInput: true,
    vipHide: false,
    bankCardLimit: 11,
    levelType: 'recharge',
    newRecharge: true, // 新版本修改后新增参数
    useNewMine: true,
    pathNewRecharge: true, // 跳转新的充值页面
    homeProfitInterval: [10, 5000],
    homeProfitIntervalMax: [11500, 11999],
    useNewWithdraw: true,
    dateFormat: "MM/dd/yyyy HH:mm:ss",
    dateFormatNoTime: "MM/dd/yyyy",
    theme: "#ff9300",
    noticeIconColor: "#000",
    homeTheme: "#e9600a",
    navBg: "#fff",
    hideLoginFooter: true
  },
  "T7408": {
    title: 'Amazonbot',
    moneyType: 'USDT',
    needBank: true,
    areaCode: 48,
    lan: 'en',
    needCode: true,
    url: 'https://amallsettlement.club/',
    unreadBg: "#febd68",
    unreadColor: "#000",
    bankInput: true,
    vipHide: false,
    bankCardLimit: 11,
    levelType: 'recharge',
    newRecharge: true, // 新版本修改后新增参数
    useNewMine: true,
    pathNewRecharge: true, // 跳转新的充值页面
    homeProfitInterval: [10, 5000],
    homeProfitIntervalMax: [11500, 11999],
    useNewWithdraw: true,
    dateFormat: "MM/dd/yyyy HH:mm:ss",
    dateFormatNoTime: "MM/dd/yyyy",
    theme: "#ff9300",
    noticeIconColor: "#000",
    homeTheme: "#e9600a",
    navBg: "#fff",
    hideLoginFooter: true
  },
  "T7408_test": {
    title: 'Amazonbot',
    moneyType: 'USDT',
    needBank: true,
    areaCode: 48,
    lan: 'en',
    needCode: true,
    url: 'https://gt7404.gtzs.cc/',
    unreadBg: "#febd68",
    unreadColor: "#000",
    bankInput: true,
    vipHide: false,
    bankCardLimit: 11,
    levelType: 'recharge',
    newRecharge: true, // 新版本修改后新增参数
    useNewMine: true,
    pathNewRecharge: true, // 跳转新的充值页面
    homeProfitInterval: [10, 5000],
    homeProfitIntervalMax: [11500, 11999],
    useNewWithdraw: true,
    dateFormat: "MM/dd/yyyy HH:mm:ss",
    dateFormatNoTime: "MM/dd/yyyy",
    theme: "#ff9300",
    noticeIconColor: "#000",
    homeTheme: "#e9600a",
    navBg: "#fff",
    hideLoginFooter: true
  },
  "T7409": {
    title: 'Amazonbot',
    moneyType: 'USDT',
    needBank: true,
    areaCode: 44,
    lan: 'en',
    needCode: true,
    url: 'https://amzn1.top/',
    unreadBg: "#febd68",
    unreadColor: "#000",
    bankInput: true,
    vipHide: false,
    bankCardLimit: 11,
    levelType: 'recharge',
    newRecharge: true, // 新版本修改后新增参数
    useNewMine: true,
    pathNewRecharge: true, // 跳转新的充值页面
    homeProfitInterval: [10, 5000],
    homeProfitIntervalMax: [11500, 11999],
    useNewWithdraw: true,
    dateFormat: "MM/dd/yyyy HH:mm:ss",
    dateFormatNoTime: "MM/dd/yyyy",
    theme: "#FE8A00",
    noticeIconColor: "#000",
    homeTheme: "#e9600a",
    navBg: "#fff",
    hideLoginFooter: true
  },
  "T7409_test": {
    title: 'Amazonbot',
    moneyType: 'USDT',
    needBank: true,
    areaCode: 44,
    lan: 'en',
    needCode: true,
    url: 'https://gt7404.gtzs.cc/',
    unreadBg: "#febd68",
    unreadColor: "#000",
    bankInput: true,
    vipHide: false,
    bankCardLimit: 11,
    levelType: 'recharge',
    newRecharge: true, // 新版本修改后新增参数
    useNewMine: true,
    pathNewRecharge: true, // 跳转新的充值页面
    homeProfitInterval: [10, 5000],
    homeProfitIntervalMax: [11500, 11999],
    useNewWithdraw: true,
    dateFormat: "MM/dd/yyyy HH:mm:ss",
    dateFormatNoTime: "MM/dd/yyyy",
    theme: "#FE8A00",
    noticeIconColor: "#000",
    homeTheme: "#e9600a",
    navBg: "#fff",
    hideLoginFooter: true
  },
  "T7503": {
    title: 'MML',
    moneyType: 'USDT',
    needBank: true,
    areaCode: 966,
    lan: 'en',
    needCode: true,
    url: 'https://mmlok.cc/',
    unreadBg: "#febd68",
    unreadColor: "#000",
    bankInput: true,
    vipHide: false,
    bankCardLimit: 11,
    levelType: 'recharge',
    newRecharge: true, // 新版本修改后新增参数
    useNewMine: true,
    pathNewRecharge: true, // 跳转新的充值页面
    homeProfitInterval: [10, 5000],
    homeProfitIntervalMax: [11500, 11999],
    useNewWithdraw: true,
    dateFormat: "yyyy/MM/dd HH:mm:ss",
    dateFormatNoTime: "yyyy/MM/dd",
    theme: "#3d3d3d",
    noticeIconColor: "#000",
    homeTheme: "#e9600a",
    navBg: "#fff",
    hideLoginFooter: true
  },
  "T7504": {
    title: 'T&E',
    moneyType: 'USDT',
    needBank: true,
    areaCode: 966,
    lan: 'en',
    needCode: true,
    url: 'https://texnyozqf.cyou/',
    unreadBg: "#febd68",
    unreadColor: "#000",
    bankInput: true,
    vipHide: false,
    bankCardLimit: 11,
    levelType: 'recharge',
    newRecharge: true, // 新版本修改后新增参数
    useNewMine: true,
    pathNewRecharge: true, // 跳转新的充值页面
    homeProfitInterval: [10, 5000],
    homeProfitIntervalMax: [11500, 11999],
    useNewWithdraw: true,
    dateFormat: "yyyy/MM/dd HH:mm:ss",
    dateFormatNoTime: "yyyy/MM/dd",
    theme: "#3d3d3d",
    noticeIconColor: "#000",
    homeTheme: "#e9600a",
    navBg: "#fff",
    hideLoginFooter: true
  },
  "A6103": {
    // title: "AGPRO",
    title:'BEST GAME',
    moneyType: '₱',
    url: 'https://starbet.xin/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.a6103light,
    areaCode: "63",
    lan: "en",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    randMoneyTypes: [
      { symbol: "฿", abbr: "THB", interval: [100, 300000] },
      { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
      { symbol: "$", abbr: "USDT", interval: [100, 10000] },
      { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USDT", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6109": {
    // title: "AGPRO",
    title:'Lucky88',
    moneyType: '₱',
    url: 'https://lucky88-ph.cc/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.a6103light,
    areaCode: "63",
    lan: "en",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    randMoneyTypes: [
      { symbol: "฿", abbr: "THB", interval: [100, 300000] },
      { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
      { symbol: "$", abbr: "USDT", interval: [100, 10000] },
      { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USDT", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6106": {
    // title: "AGPRO",
    title:'Grand Lisboa Casino - A prestigious brand, reputation first.',
    moneyType: '$',
    url: 'https://116459641.cyou/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.a6106light,
    areaCode: 183,
    lan: "en",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    randMoneyTypes: [
      { symbol: "฿", abbr: "THB", interval: [100, 300000] },
      { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
      { symbol: "$", abbr: "USDT", interval: [100, 10000] },
      { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USDT", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6106_test": {
    // title: "AGPRO",
    title:'Grand Lisboa Casino - A prestigious brand, reputation first.',
    moneyType: '$',
    url: 'https://ga6106.csvip.top/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.a6106light,
    areaCode: 183,
    lan: "en",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    randMoneyTypes: [
      { symbol: "฿", abbr: "THB", interval: [100, 300000] },
      { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
      { symbol: "$", abbr: "USDT", interval: [100, 10000] },
      { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USDT", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6107": {
    title:'DaFa 518.COM',
    moneyType: '₹',
    url: 'https://3738.com/',
    navTheme: "#ffffffe6",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.a6107light,
    areaCode: 183,
    lan: "en",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    randMoneyTypes: [
      { symbol: "฿", abbr: "THB", interval: [100, 300000] },
      { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
      { symbol: "$", abbr: "USDT", interval: [100, 10000] },
      { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USDT", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6108": {
    // title: "AGPRO",
    title:'Luckgo',
    moneyType: '₱',
    url: 'https://luckgo7788.shop/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.a6103light,
    areaCode: "63",
    lan: "en",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    randMoneyTypes: [
      { symbol: "฿", abbr: "THB", interval: [100, 300000] },
      { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
      { symbol: "$", abbr: "USDT", interval: [100, 10000] },
      { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USDT", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6104": {
    title: "YG88",
    moneyType: 'USD',
    url: 'https://yg99s.com/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.a6103light,
    areaCode: "62",
    lan: "idn",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    randMoneyTypes: [
      { symbol: "฿", abbr: "THB", interval: [100, 300000] },
      { symbol: "RM", abbr: "RM", interval: [1000, 200000] },
      { symbol: "$", abbr: "USDT", interval: [100, 10000] },
      { symbol: "S$", abbr: "SGD", interval: [100, 100000] },
    ],
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USDT", "GBP"],
    needBank: true,
    useNewUsername: true
  },
  "A6105": {
    title: "RoyalGames",
    moneyType: 'Rp',
    url: 'https://royalgames.shop/',
    // navTheme: "#0d192c",
    // theme: "#00bbfe",
    // pagesBG: "#e4f0fa",
    themes: themes.a6103light,
    areaCode: "62",
    lan: "idn",
    loginBG: require("@tt/assets/login/loginBG_A6405.png"),
    rechargeSelectCurrency: ["THB", "RM", "SGD", "USDT", "GBP"],
    needBank: true,
    useNewUsername: true,
    moneyFormatWithBrazil:true
  },
}

export default verData[ver];